<template>
	<div class="brick" style="width:1200px;">
		<label v-if="restriction_only_available" class="mgr_15"><input type="checkbox" v-model="restriction_only" @change="onStateReportChange" /> Restriction Only</label>
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Item {{ headers.class }}</em>
				<span class="int_type_no_border mgr_5"> <ItemClassSelect v-model="class_code" :showName="false" :codeWidth="100" /> </span>
				<em class="lt_text">Invoice Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="from_date"/> ~ <CustomDatePicker v-model="to_date"/></span>
				<a href="javascript:void(0);" class="search_bt" @click="selectData()">Search</a>
				<span>Searches the sales between 'from date' and 'to date', with no sales within 1 year 'from date'.</span>
			</div>
		</div>
		<div class="fixed-table-container" style="height:970px;">
			<div class="table-wrapper">
				<table id="item_list" class="list_tbl tbl_pointer" border="0">
					<!-- <table class="list_tbl sticky_list_tbl"> -->
					<thead>
						<tr>
							<th style="width:200px">Sales Group</th>
							<th style="width:130px">Ship To Code</th>
							<th>Ship To Name</th>
							<th style="width:120px">Invoice Amount</th>
							<th style="width:100px">Invoice Date</th>
							<th style="width:130px">Invoice No</th>
							<th style="width:70px">Quantity</th>
							<th style="width:100px">Amount</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(invoice, index) in invoices" v-bind:key="index">
							<td>{{ invoice.sales_group_name }}</td>
							<td>{{ invoice.ship_to_code }}</td>
							<td>{{ invoice.ship_to_name }}</td>
							<td class="al_right">{{ invoice.invoice_amount | toCurrency }}</td>
							<td>{{ invoice.invoice_date }}</td>
							<td>
								<a href="javascript:;" @click="gotoInvoice(invoice.invoice_no)">{{ invoice.invoice_dn }}</a>
							</td>
							<td class="al_right">{{ invoice.total_shipped_quantity | commaSeparated }}</td>
							<td class="al_right">{{ invoice.total_shipped_amount | toCurrency }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div style="text-align:right;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}</div>

		<div class="bottom_bt_box">
			<ul>
				<li>
					<a href="javascript:void(0);" v-on:click="excel">Excel</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import stateReport from '@/mixins/stateReport';
import { apiSelectFirstSaleCustomerList } from '@/api/report/report';
import { exportDataExcel } from '@/api/util';
import { defaultDataType } from 'export-xlsx';
import CustomDatePicker from '@/components/common/CustomDatePicker';
import { today, toText } from '@/utils/date';
import ItemClassSelect from '@/components/common/ItemClassSelect';

export default {
	mixins: [stateReport({ id: 'FirstSale', search: 'selectData', queries: ['selectData'], results: ['invoices', 'list_count'] })],
	props: ['headers'],
	data: function() {
		return {
			root: '',

			backUri: '/',
			paging_yn: 'Y',
			page_size: 28,
			page_no: 1,
			list_count: 0,

			from_date: today(),
			to_date: today(),

			//class_code: null,
			class_code: null,

			invoices: [],
			// excelItems: [],
			// saveParam: {},

			// item_classes_string: '',
			// item_classes: [],

			// keyword: null,
		};
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
	},
	components: {
		CustomDatePicker,
		ItemClassSelect,
	},
	methods: {
		// setSearchClass(ic) {
		// 	console.log(ic);
		// 	this.itemClass = ic;
		// 	//this.selectData();
		// },
		gotoInvoice(invoice_no) {
			//this.$router.push({ name: 'invoiceDetail', params: { mode: 'detail' }, query: this.stateReportQuery({ backUri: this.$route.fullPath, invoice_no: invoice_no }) });
			let routeData = this.$router.resolve({ name: 'invoiceDetail', params: { mode: 'detail' }, query: this.stateReportQuery({ backUri: this.uri, invoice_no: invoice_no }) });
			window.open(routeData.href, 'herp_invoice');
		},
		async selectData() {
			if (!this.class_code) {
				this.$toast.error('Empty class');
				return;
			}
			if (!this.from_date) {
				this.$toast.error('Empty From Date');
				return;
			}
			if (!this.to_date) {
				this.$toast.error('Empty To Date');
				return;
			}

			const param = {
				class_code: this.class_code,
				from_date: this.from_date,
				to_date: this.to_date,
			};

			const { data } = await apiSelectFirstSaleCustomerList.call(this, param);
			this.invoices = data.invoiceList;
			//console.log(this.invoices);

			this.list_count = this.invoices.length;
		},
		async init() {
			var date = new Date();
			this.from_date = toText(new Date(date.getFullYear(), date.getMonth(), 1), '-');
			this.to_date = toText(new Date(date.getFullYear(), date.getMonth() + 1, 0), '-');
		},
		async excel() {
			const state_output = this.captureStateReportOutput();
			if (!state_output) return;
			var vm = this;
			this.invoices.forEach(i => {
				i.class_code = vm.class_code;
			});
			let fileName = 'FirstSale_' + this.class_code + '_' + this.from_date + '_' + this.to_date;
			let headers = [
				{ key: 'class_code', name: 'Class Code', width: 15, dataType: defaultDataType.string },
				{ key: 'sales_group_name', name: 'Sales Group', width: 20, dataType: defaultDataType.string },
				{ key: 'ship_to_code', name: 'Ship To Code', width: 15, dataType: defaultDataType.string },
				{ key: 'ship_to_name', name: 'Ship To name', width: 45, dataType: defaultDataType.string },
				{ key: 'invoice_amount', name: 'Invoice Amount', width: 15, dataType: defaultDataType.number },
				{ key: 'invoice_date', name: 'Invoice Date', width: 15, dataType: defaultDataType.string },
				{ key: 'invoice_dn', name: 'Invoice No', width: 20, dataType: defaultDataType.string },
				{ key: 'total_shipped_quantity', name: 'Quantity', width: 10, dataType: defaultDataType.currency },
				{ key: 'total_shipped_amount', name: 'Amount', width: 15, dataType: defaultDataType.number },
			];

			if (!state_output.valid) return;

			exportDataExcel(this.invoices, headers, fileName);
		},
		reset() {},
	},

	mounted() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_first_sale');
		this.$store.commit('setSubTitle', 'Report -> First Sale');
		this.init();
	},
};
</script>

<style scoped></style>
